import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React, { useState, useEffect } from 'react';
import { shape, number, arrayOf, string, bool } from 'prop-types';
import _jsx from '@babel/runtime/helpers/jsx';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import get from 'lodash/get';
import { backgroundColor, colornames, sizenames, familynames, constants, getCookie, trackEvent, ONE_SECOND, getTimerText } from '@vpp-frontend-components/common';
import { useViewCounter, useInterval } from '@vpp-frontend-components/hooks';
import { Tooltip, TOOLTIP_CONSTANTS, useTooltipProps, TooltipWrapper } from '@vpp-frontend-components/tooltip';
import { Icon } from '@vpp-frontend-components/icon';
import { Media } from '@vpp-frontend-components/media';
import classNames from 'classnames';
import { componentEnhance } from '@vpp-frontend-components/component-enhance';
shape({
  initial_time: number.isRequired,
  total_milliseconds: number.isRequired,
  hours: number.isRequired,
  minutes: number.isRequired,
  pay_before_hour: number.isRequired,
  labels: arrayOf(shape({
    id: string.isRequired,
    text: string.isRequired,
    color: string.isRequired,
    values: shape({})
  })).isRequired
});
const namespace$6 = 'ui-pdp-promotions-pill-label';
const getStyleProps = _ref => {
  let {
    bg_color,
    color,
    campaign,
    className,
    font_family,
    font_size,
    text_icon
  } = _ref;
  const bGroundHexOrRgb = bg_color.includes('#') || bg_color.includes('rgb');
  const fontColorHexOrRgb = (color === null || color === void 0 ? void 0 : color.includes('#')) || (color === null || color === void 0 ? void 0 : color.includes('rgb'));
  const myStyle = {};
  if (bGroundHexOrRgb) {
    myStyle.backgroundColor = bg_color;
  }
  if (fontColorHexOrRgb) {
    myStyle.color = color;
  }
  return {
    style: myStyle,
    className: classNames(namespace$6, campaign, className, backgroundColor(!bGroundHexOrRgb && bg_color), colornames(!fontColorHexOrRgb && color), sizenames(font_size), familynames(font_family), {
      [`${namespace$6}--with-icon`]: !!text_icon
    })
  };
};

/* eslint-disable @typescript-eslint/naming-convention */
const icon = shape({
  id: string,
  alignment: string,
  accessibility_text: string
});
shape({
  text: string.isRequired,
  color: string.isRequired,
  bg_color: string,
  font_size: string,
  campaign: string,
  text_icon: icon,
  position: string,
  tooltip_icon: icon
});
shape({
  id: string,
  state: string,
  closed: bool,
  storable: bool,
  body: shape({
    text: string
  })
});
shape({
  id: string,
  state: string,
  closeable: bool,
  closed: bool,
  storable: bool,
  has_shadow: bool,
  change_color: bool,
  behaviour: string,
  tooltip_type: string,
  side: string,
  components: arrayOf(shape({}))
});
shape({
  melidata_event: shape({})
});
const {
  RIGHT: RIGHT$1
} = constants.icon;
const namespace$5 = 'ui-pdp-promotions-pill-label';
const getComponents = (alignment, targetLink, text_icon) => {
  const media = /*#__PURE__*/_jsx(Media, {
    className: `${namespace$5}__icon`,
    accessibilityText: text_icon === null || text_icon === void 0 ? void 0 : text_icon.accessibility_text,
    figure: /*#__PURE__*/React.createElement(Icon, text_icon)
  });
  const components = [media, targetLink];
  if (alignment === RIGHT$1) {
    return components.reverse();
  }

  // if (alignment === LEFT)
  return components;
};
const TagMedia = _ref => {
  let {
    label,
    target,
    padding
  } = _ref;
  const {
    text,
    text_icon,
    tooltip_icon
  } = label;
  const targetLink = target ? /*#__PURE__*/_jsx("a", {
    className: `${namespace$5}__target`,
    href: target
  }, void 0, text) : /*#__PURE__*/_jsx("span", {
    className: `${namespace$5}__text`,
    style: {
      padding
    }
  }, void 0, text);
  const alignment = (text_icon === null || text_icon === void 0 ? void 0 : text_icon.alignment) || 'left';
  return /*#__PURE__*/_jsx("div", {
    className: `${namespace$5}__trigger`
  }, void 0, text_icon ? getComponents(alignment, targetLink, text_icon) : targetLink, tooltip_icon && /*#__PURE__*/React.createElement(Icon, tooltip_icon));
};
const namespace$4 = 'ui-pdp-promotions-pill-label';
const TOOLTIP_DESCRIPTION_RECOMENDED = 'TOOLTIP_DESCRIPTION_RECOMENDED';
const {
  SIDE: SIDE$1,
  TRIGGER: TRIGGER$1
} = TOOLTIP_CONSTANTS;
const OFFSETS$1 = {
  MOBILE: {
    X: -2,
    Y: 16
  },
  DESKTOP: {
    X: -10,
    Y: 0
  }
};
const TooltipTag = _ref => {
  let {
    label,
    andes_tooltip,
    mobile,
    firstPrint,
    handleOpen,
    handleClose,
    target,
    padding
  } = _ref;
  const media = /*#__PURE__*/React.createElement(TagMedia, {
    label,
    target,
    padding
  });
  if ((andes_tooltip === null || andes_tooltip === void 0 ? void 0 : andes_tooltip.state) !== 'VISIBLE') {
    return media;
  }
  const plataformProps = mobile ? {
    offsetX: OFFSETS$1.MOBILE.X,
    offsetY: OFFSETS$1.MOBILE.Y,
    trigger: TRIGGER$1.CLICK,
    side: SIDE$1.BOTTOM_LEFT
  } : {
    offsetX: OFFSETS$1.DESKTOP.X,
    offsetY: OFFSETS$1.DESKTOP.Y,
    trigger: TRIGGER$1.HOVER,
    side: SIDE$1.LEFT
  };
  const {
    text,
    values
  } = (andes_tooltip === null || andes_tooltip === void 0 ? void 0 : andes_tooltip.body) || {};
  const content = values ? componentEnhance.jsx(text, values) : text;
  return /*#__PURE__*/React.createElement(Tooltip, _extends({
    id: TOOLTIP_DESCRIPTION_RECOMENDED,
    className: `${namespace$4}__icon ${namespace$4}__tooltip`,
    content: content,
    closable: firstPrint,
    onOpen: handleOpen,
    onClose: handleClose
  }, plataformProps), media);
};
const TOOLTIP_OFICCIAL_STORE = 'official_store_highlight_tooltip';
const LabelTooltip = _ref => {
  let {
    className = '',
    label = {
      bg_color: null,
      campaign: null,
      font_size: 'XXSMALL',
      text_icon: null
    },
    font_family = 'SEMIBOLD',
    tooltip,
    andes_tooltip = {
      id: '',
      state: '',
      closed: null,
      storable: null,
      body: {
        text: ''
      }
    },
    target = '',
    mobile = false,
    padding = '',
    track = null,
    runCatchErrorBoundary = () => {}
  } = _ref;
  try {
    /* eslint-disable react-hooks/rules-of-hooks */
    const {
      color,
      bg_color,
      text_icon,
      font_size,
      campaign
    } = label;
    const [visible, setVisibility] = useState(!andes_tooltip.closed);
    const [firstPrint, setFirstPrint] = useState(false);
    const cookieName = 'tooltips-configuration';
    const isOfficialStore = (andes_tooltip === null || andes_tooltip === void 0 ? void 0 : andes_tooltip.id) === TOOLTIP_OFICCIAL_STORE;
    const updateCloseStatus = useViewCounter({
      id: andes_tooltip.id,
      visible,
      storable: andes_tooltip.storable,
      cookieName
    });
    useEffect(() => {
      if (isOfficialStore) {
        const andesCookie = getCookie(cookieName);
        if (andesCookie) {
          const tooltipOfficialStore = get(andesCookie, `${cookieName}.${andes_tooltip.id}`, {
            view_cnt: 0,
            close_cnt: 0
          });
          const {
            close_cnt = 0
          } = tooltipOfficialStore;
          if (close_cnt > 0) {
            setVisibility(false);
            setFirstPrint(false);
          }
        }
      }
    }, [andes_tooltip.id, isOfficialStore, track]);
    const handleClose = () => {
      setVisibility(false);
      setFirstPrint(false);
      if (andes_tooltip.storable) {
        updateCloseStatus();
      }
      if (mobile) {
        if (isOfficialStore && andes_tooltip !== null && andes_tooltip !== void 0 && andes_tooltip.track) {
          trackEvent(andes_tooltip === null || andes_tooltip === void 0 ? void 0 : andes_tooltip.track);
        }
      }
    };
    const handleOpen = () => {
      if (track && mobile) {
        trackEvent(track);
      }
    };
    const tooltipProps = _objectSpread(_objectSpread({}, useTooltipProps(null, tooltip)), {}, {
      offsetX: -15
    });
    return /*#__PURE__*/_jsx(TooltipWrapper, {
      tooltip: tooltip ? tooltipProps : null
    }, void 0, /*#__PURE__*/React.createElement("div", getStyleProps({
      bg_color,
      color,
      campaign,
      className,
      font_family,
      font_size,
      text_icon
    }), /*#__PURE__*/React.createElement(TooltipTag, {
      label,
      andes_tooltip,
      mobile,
      firstPrint,
      handleOpen,
      handleClose,
      target,
      padding
    })));
    /* eslint-enable react-hooks/rules-of-hooks */
  } catch (error) {
    /* istanbul ignore next */
    return runCatchErrorBoundary(error);
  }
};
const {
  RIGHT
} = constants.icon;
const namespace$3 = 'ui-pdp-promotions-pill-label';
const Label = _ref => {
  let {
    className = '',
    text,
    bg_color = null,
    font_size = 'XXSMALL',
    font_family = 'SEMIBOLD',
    campaign = null,
    color,
    text_icon
  } = _ref;
  const {
    alignment
  } = text_icon || {};
  return /*#__PURE__*/_jsx("div", {
    className: classNames(namespace$3, campaign, className, backgroundColor(bg_color), colornames(color), sizenames(font_size), familynames(font_family), {
      [`${namespace$3}--with-icon`]: !!text_icon
    })
  }, void 0, text_icon ? /*#__PURE__*/React.createElement(React.Fragment, null, alignment === RIGHT && /*#__PURE__*/_jsx("span", {
    className: `${namespace$3}__text`
  }, void 0, text), /*#__PURE__*/_jsx(Media, {
    className: `${namespace$3}__icon`,
    figure: /*#__PURE__*/React.createElement(Icon, text_icon)
  }), alignment !== RIGHT && /*#__PURE__*/_jsx("span", {
    className: `${namespace$3}__text`
  }, void 0, text)) : text);
};
const namespace$2 = 'ui-pdp-promotions-pill';
const PromotionsPill = _ref => {
  let {
    className = '',
    labels = [],
    runCatchErrorBoundary = () => {}
  } = _ref;
  try {
    return /*#__PURE__*/_jsx("div", {
      className: classNames(namespace$2, className)
    }, void 0, labels.map(label => /*#__PURE__*/React.createElement(Label, _extends({}, label, {
      key: `label-${label.text}`
    }))));
  } catch (error) {
    /* istanbul ignore next */
    return runCatchErrorBoundary(error);
  }
};
const {
  SIDE,
  TRIGGER
} = TOOLTIP_CONSTANTS;
const OFFSETS = {
  MOBILE: {
    X: -5,
    Y: 32
  },
  DESKTOP: {
    X: -10,
    Y: 12
  }
};
const TooltipHighligh = _ref => {
  let {
    namespace,
    tooltip,
    mobile
  } = _ref;
  const plataformProps = mobile ? {
    offsetX: OFFSETS.MOBILE.X,
    offsetY: OFFSETS.MOBILE.Y,
    side: SIDE.BOTTOM_LEFT
  } : {
    offsetX: OFFSETS.DESKTOP.X,
    offsetY: OFFSETS.DESKTOP.Y,
    side: SIDE.LEFT
  };
  return /*#__PURE__*/React.createElement(Tooltip, _extends({
    className: `${namespace}__tooltip ${namespace}__tooltip--${tooltip.id}`,
    id: tooltip.id,
    content: tooltip.body.text,
    trigger: TRIGGER.CLICK,
    storable: tooltip.storable,
    visible: true,
    mask: true,
    maskClosable: false
  }, plataformProps), /*#__PURE__*/_jsx("div", {
    className: `${namespace}__trigger-tooltip`
  }));
};
const namespace$1 = 'ui-pdp-promotions-pill';
const getPadding = tag_action => {
  const paddingTop = get(tag_action, 'label.padding.top', 0);
  const paddingBottom = get(tag_action, 'label.padding.bottom', 0);
  const paddingRight = get(tag_action, 'label.padding.right', 0);
  const paddingLeft = get(tag_action, 'label.padding.left', 0);
  return `${paddingTop}px ${paddingRight}px ${paddingBottom}px ${paddingLeft}px`;
};
const getMarginTop = tag_action => get(tag_action, 'margin.top', null);
const PromotionsHighlights = _ref => {
  let {
    className = '',
    tooltip = null,
    tag_action = null,
    description_action = null,
    mobile = false,
    viewport_track = null,
    runCatchErrorBoundary = () => {}
  } = _ref;
  try {
    useEffect(() => {
      if (viewport_track) {
        trackEvent(viewport_track);
      }
    }, [viewport_track]);
    return /*#__PURE__*/_jsx("div", {
      className: classNames(namespace$1, className),
      style: {
        marginTop: getMarginTop(tag_action)
      }
    }, void 0, tooltip && /*#__PURE__*/_jsx(TooltipHighligh, {
      namespace: namespace$1,
      tooltip: tooltip,
      mobile: mobile
    }, tooltip.id), tag_action && /*#__PURE__*/React.createElement(LabelTooltip, _extends({}, tag_action, {
      padding: getPadding(tag_action),
      key: `label-${tag_action.label.text}`,
      mobile: mobile
    })), (description_action === null || description_action === void 0 ? void 0 : description_action.label) && /*#__PURE__*/React.createElement(LabelTooltip, _extends({}, description_action, {
      padding: getPadding(tag_action),
      key: `label-${description_action.label.text}`,
      mobile: mobile,
      runCatchErrorBoundary: runCatchErrorBoundary
    })));
  } catch (error) {
    /* istanbul ignore next */
    return runCatchErrorBoundary(error);
  }
};
const namespace = 'ui-pdp-promotions-progress';
const PromotionsProgress = _ref => {
  let {
    className = '',
    progress = null,
    remaining = null,
    runCatchErrorBoundary = () => {}
  } = _ref;
  try {
    /* eslint-disable react-hooks/rules-of-hooks */
    const {
      percentage,
      label,
      color,
      bg_color,
      empty_color = 'MEDIUM_GRAY'
    } = progress;
    const {
      total_milliseconds,
      labels
    } = remaining;
    const isHexaColor = color === null || color === void 0 ? void 0 : color.includes('#');
    // eslint-disable-next-line react/hook-use-state
    const [finishTime] = useState(Date.now() + total_milliseconds + ONE_SECOND);
    const [time, setTime] = useState(total_milliseconds);
    const [before, timer, after] = getTimerText(time, labels) || [];
    const timeout = timer === null;
    useInterval(() => {
      setTime(finishTime - Date.now());
    }, ONE_SECOND);
    return /*#__PURE__*/_jsx("div", {
      className: classNames(namespace, className)
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: classNames(`${namespace}__bar`, backgroundColor(timeout ? empty_color : bg_color))
    }, void 0, !timeout && /*#__PURE__*/_jsx("div", {
      className: classNames('progress', !isHexaColor && backgroundColor(color)),
      style: {
        width: `${percentage}%`,
        backgroundColor: isHexaColor && color
      }
    })), /*#__PURE__*/_jsx("div", {
      className: `${namespace}__status`
    }, void 0, !timeout && /*#__PURE__*/_jsx("span", {
      className: "sold"
    }, void 0, label === null || label === void 0 ? void 0 : label.text), /*#__PURE__*/_jsx("span", {
      className: "remaining"
    }, void 0, before, !timeout && /*#__PURE__*/_jsx("span", {
      className: "timer"
    }, void 0, timer), after)));
    /* eslint-enable react-hooks/rules-of-hooks */
  } catch (error) {
    /* istanbul ignore next */
    return runCatchErrorBoundary(error);
  }
};
const _excluded = ["remaining", "type"];
const Promotions = _ref => {
  let {
      remaining = null,
      type = null
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const types = {
    promotions: remaining === null ? /*#__PURE__*/React.createElement(PromotionsPill, props) : null,
    highlights_information: /*#__PURE__*/React.createElement(PromotionsHighlights, props),
    pill_information: /*#__PURE__*/React.createElement(PromotionsPill, props),
    progress_bar: /*#__PURE__*/React.createElement(PromotionsProgress, _extends({
      remaining: remaining
    }, props))
  };
  return types[type] || null;
};
export { Label, LabelTooltip, Promotions, PromotionsHighlights, PromotionsPill, PromotionsProgress };
